import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { updatePropertyRecipe } from '@/redux/utils/update-property-recipe';
import { Policy } from '@/types/policy';
import { UpdateAccessibilitySettingsQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchUpdateAccessibilitySettings: DispatchOptimisticPatchHandler<
  UpdateAccessibilitySettingsQueryArg
> = ({ organisation, accessibility }, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getPolicies',
      { organisation },
      updatePropertyRecipe<Policy, 'accessibility'>(
        'accessibility',
        accessibility,
      ),
    ),
  );

  return { patch };
};
